import { useState } from 'react';
import { FieldArrayWithId } from 'react-hook-form';
import { ISelectionFormValues } from 'widgets/selections/utils/types';

interface UseDragAndDropProps {
  fields: FieldArrayWithId<Pick<ISelectionFormValues, 'options'>, 'options', 'key'>[];
  moveOption: (indexA: number, indexB: number) => void;
}

export const useDragAndDrop = ({ fields, moveOption }: UseDragAndDropProps) => {
  const [activeId, setActiveId] = useState<string | null>(null);

  const onDragStart = ({ active }) => setActiveId(active.id as string);

  const onDragEnd = ({ active, over }) => {
    if (over && active.id !== over.id) {
      const oldIndex = fields.findIndex((i) => i.id === active.id);
      const newIndex = fields.findIndex((i) => i.id === over.id);
      moveOption(oldIndex, newIndex);
    }

    setActiveId(null);
  };

  const scrollToSelectedOption = () => {
    setTimeout(() => {
      const menu = document.querySelector<HTMLElement>('[role="listbox"]');
      const selectedItem = menu?.querySelector<HTMLElement>('[aria-selected="true"]');
      selectedItem?.scrollIntoView({ block: 'nearest' });
    }, 0);
  };

  return { activeId, onDragStart, onDragEnd, scrollToSelectedOption };
};
